// angular
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// types
import { IContactFormData } from '../types/contact-form.type';

@Injectable()
export class AboutService {
  private readonly _http = inject(HttpClient);
  constructor() {}

  private _postContactFormData(data: IContactFormData) {
    return this._http.post('main/contact-us', { ...data });
  }

  public submitContactFormData(data: IContactFormData) {
    return this._postContactFormData(data);
  }
}
